import { useMemo } from "react";
import { type SelectFieldProps, SelectField, useGetList } from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

export const TrafficSourceField = (
  props: Pick<SelectFieldProps, "source" | "sortable" | "label">,
) => {
  const { isPending, data = [] } = useGetList<{
    id: string;
  }>(MODULE_NAMES.TRAFFIC_SOURCES);

  const choices = useMemo(
    () =>
      data.map((item) => ({
        ...item,
        ["@id"]: `/api/vpn/traffic_sources/${item.id}`,
      })),
    [data],
  );

  return (
    <SelectField
      source={props.source}
      sortable={props.sortable}
      isPending={isPending}
      optionValue="@id"
      optionText="title"
      label={props.label}
      choices={choices}
    />
  );
};
